import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSpielbergMinimapMarkers = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={375}
      height={375}
      fill="none"
      viewBox="0 0 375 375"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#icon-spielberg-minimap-markers_svg__a)">
        <path
          fill="url(#icon-spielberg-minimap-markers_svg__b)"
          fillOpacity={0.2}
          stroke="#fff"
          strokeOpacity={0.1}
          strokeWidth={10}
          d="M162.861 92.167c-19.611-2.674-68.195-12.777-78-14.412C77.84 76.585 71.2 75.95 62 75.681a427.478 427.478 0 0 0-12.352-.154c-12.1 0-25.643 1.782-32.148 2.871-.523.088-1.002.171-1.43.249-6.685.743-5.2 4.606-4.16 5.943.232.298.551.717 1.138 1.41 2.043 2.413 7.336 8.152 23.526 23.699.815.782 1.607 1.549 2.378 2.301 20.467 19.954 25.918 29.388 31.645 38.408 5.943 9.36 16.195 35.806 27.784 58.835 11.065 21.99 35.814 55.089 43.328 64.757.355.457.672.861.946 1.21 4.989 6.327 8.683 12.854 11.08 17.376.53 1 .997 1.901 1.401 2.681 1.783 3.447 4.407 3.616 5.497 3.269l1.867-.507c5.58-1.514 13.569-3.686 20-5.443 4.889-1.335 8.878-2.431 10.225-2.816 4.16-1.188 124.356-33.875 140.996-38.926 10.25-3.112 17.174-6.956 21.779-10.04 2.871-1.923 4.841-3.55 6.153-4.52 2.734-2.021 2.625-5.696 2.229-7.281A3690.529 3690.529 0 0 0 357.88 208c-2.54-8.767-4.859-16.571-5.438-17.923-.8-1.866-1.069-3.733-2.587-6.077-1.019-1.574-2.602-3.363-5.288-5.512-2.5-1.999-5.727-2.94-9.067-3.334-4.671-.55-9.563-.032-13 .154-.679.037-1.301.06-1.853.06-5.349 0-98.207 1.783-115.888 2.823-17.68 1.04-31.646 16.492-36.103 22.881a42.107 42.107 0 0 1-2.156 2.852c-4.008 4.807-9.046 7.877-18.942 7.251-3.1-.197-5.788-1.1-8.058-2.347-3.512-1.929-6.021-4.68-7.5-6.907a15.215 15.215 0 0 1-1.082-1.889c-5.051-8.964-15.986-28.348-19.314-34.172-1.982-3.468-3.065-6.98-3.33-10.36-.29-3.716.409-7.274 1.992-10.441 2.946-5.891 5.651-8.8 9.234-10.649 1.296-.669 2.708-1.2 4.287-1.682 5.348-1.635 7.131-1.294 11.143-.743 6.487.891 22.434 3.714 38.183 5.943 18.816 2.662 26.149.594 37.886-4.903a39.924 39.924 0 0 0 4.001-2.174c9.013-5.553 17.384-15.04 20.739-22.351.476-1.037.851-2.03 1.112-2.961.743-2.972-.736-5.343-2.525-7.132-2.08-2.08-5.201-2.228-5.795-2.228-.063 0-.248-.006-.531-.015a2592.94 2592.94 0 0 1-11.058-.431c-2.392 0-10.249-.2-19.942-.695-10.774-.55-23.815-1.463-34.139-2.87Z"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M362.323 223.5c.571 2.01 1.099 3.874 1.559 5.503.396 1.585.505 5.26-2.229 7.281-1.312.97-3.282 2.597-6.153 4.52"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M357.883 208a3286.482 3286.482 0 0 1 4.443 15.5"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M349.855 184c1.519 2.344 1.787 4.211 2.587 6.077.579 1.352 2.899 9.156 5.438 17.923"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M335.5 175.154c3.34.394 6.567 1.335 9.067 3.335 2.686 2.148 4.269 3.937 5.288 5.511"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M322.5 175.308c3.437-.186 8.329-.705 13-.154"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M166.5 203.924a42.107 42.107 0 0 0 2.156-2.852c4.457-6.389 18.423-21.84 36.103-22.881 17.681-1.04 110.539-2.822 115.888-2.822.552 0 1.174-.024 1.853-.061"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M139.5 208.828a19.113 19.113 0 0 0 8.058 2.347c9.896.626 14.934-2.444 18.942-7.251"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M132 201.92c1.479 2.228 3.988 4.979 7.5 6.908"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M108.273 155.5c.265 3.38 1.348 6.892 3.33 10.36 3.328 5.824 14.263 25.208 19.314 34.172.26.551.621 1.195 1.082 1.889"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M119.501 134.41c-3.583 1.849-6.288 4.758-9.234 10.649-1.583 3.167-2.282 6.725-1.992 10.441"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M134.93 131.985c-4.012-.551-5.795-.891-11.143.743-1.579.482-2.991 1.013-4.287 1.682"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M134.93 131.985c6.487.891 22.434 3.714 38.183 5.943 18.816 2.662 26.149.594 37.886-4.903a39.924 39.924 0 0 0 4.001-2.174"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M235.739 108.5c-3.355 7.311-11.726 16.798-20.739 22.351"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M228 96.164c.283.01.468.015.531.015.594 0 3.715.148 5.795 2.228 1.789 1.789 3.268 4.16 2.525 7.132a20.285 20.285 0 0 1-1.112 2.961"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M228.531 96.179c-.063 0-.248-.005-.531-.015a2592.94 2592.94 0 0 1-11.058-.43c-2.392 0-10.249-.2-19.942-.695"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M62 75.681c9.202.268 15.84.905 22.86 2.075 9.806 1.634 58.39 11.737 78.001 14.411 10.324 1.408 23.365 2.322 34.139 2.871"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M17.5 78.398c6.505-1.09 20.048-2.871 32.148-2.871 4.644 0 8.7.048 12.352.154"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M13.048 86c-.587-.693-.905-1.112-1.137-1.41-1.04-1.337-2.526-5.2 4.16-5.943.427-.078.905-.16 1.429-.249"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M38.951 112a423.792 423.792 0 0 0-2.378-2.301C20.383 94.152 15.09 88.414 13.047 86"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M141.71 274c-7.515-9.668-32.263-42.767-43.329-64.757-11.588-23.029-21.84-49.475-27.783-58.835-5.727-9.02-11.178-18.454-31.645-38.408"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M153.737 292.586c-2.397-4.522-6.091-11.049-11.08-17.376-.274-.349-.591-.753-.946-1.21"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="m162.499 298.029-1.867.507c-1.09.346-3.715.178-5.497-3.269-.404-.78-.871-1.681-1.401-2.681"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M182.5 292.586c-6.431 1.757-14.42 3.928-20 5.443"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M182.5 292.586c4.889-1.335 8.878-2.431 10.225-2.816 4.16-1.189 124.356-33.875 140.996-38.926 10.25-3.112 17.174-6.956 21.779-10.04"
        />
        <g filter="url(#icon-spielberg-minimap-markers_svg__c)">
          <path
            fill="#fff"
            fillOpacity={0.95}
            d="m240.234 253.085 3.89-1.043 1.172 4.372-3.89 1.043zM242.578 261.828l3.89-1.043 1.172 4.372-3.89 1.043zM244.918 270.571l3.89-1.043 1.172 4.372-3.89 1.043zM247.262 279.315l3.89-1.043 1.172 4.372-3.89 1.043zM249.605 288.058l3.89-1.043 1.172 4.372-3.89 1.043zM245.297 256.414l3.89-1.043 1.172 4.372-3.89 1.043zM247.641 265.157l3.89-1.043 1.172 4.372-3.89 1.043zM249.98 273.9l3.89-1.043 1.172 4.372-3.89 1.043zM252.324 282.644l3.89-1.043 1.172 4.372-3.89 1.043z"
          />
          <path
            fill="#000"
            d="m244.125 252.043 3.89-1.043 1.172 4.372-3.89 1.043zM246.469 260.786l3.89-1.043 1.172 4.372-3.89 1.043zM248.812 269.529l3.89-1.043 1.172 4.372-3.89 1.043zM251.152 278.272l3.89-1.043 1.172 4.372-3.89 1.043zM253.496 287.015l3.89-1.043 1.172 4.372-3.89 1.043zM241.406 257.457l3.89-1.043 1.172 4.372-3.89 1.043zM243.75 266.2l3.89-1.043 1.172 4.372-3.89 1.043zM246.09 274.943l3.89-1.043 1.172 4.372-3.89 1.043z"
          />
          <path
            fill="#000"
            d="m248.434 283.686 3.89-1.043 1.172 4.372-3.89 1.043z"
          />
          <path
            fill="#E2645A"
            d="m227.19 304.599 16.865 5.684-5.114-19.087-11.751 13.403Zm-2.187.585c-.188-.703-.075-1.437.402-1.967l12.339-14.013c.941-1.107 2.637-.555 3.051.992l5.379 20.073c.402 1.5-.778 2.872-2.134 2.431l-17.705-6.012a2.21 2.21 0 0 1-1.332-1.504Z"
          />
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__d)">
          <rect
            width={20}
            height={20}
            x={154}
            y={268}
            fill="url(#icon-spielberg-minimap-markers_svg__e)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__f)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m163.827 275.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__g)">
          <rect
            width={20}
            height={20}
            x={36}
            y={136}
            fill="url(#icon-spielberg-minimap-markers_svg__h)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__i)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m43.005 148.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V150h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__j)">
          <rect
            width={20}
            height={20}
            x={31}
            y={81}
            fill="url(#icon-spielberg-minimap-markers_svg__k)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__l)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M37.787 93.764v-1.188h1.392v.768l.468.456h2.28l.468-.456V91.82l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L42.55 95h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__m)">
          <rect
            width={20}
            height={20}
            x={203}
            y={99}
            fill="url(#icon-spielberg-minimap-markers_svg__n)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__o)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M213.707 111.392h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V113h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__p)">
          <rect
            width={20}
            height={20}
            x={171}
            y={109}
            fill="url(#icon-spielberg-minimap-markers_svg__q)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__r)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M177.889 121.764v-1.224h1.392v.804l.468.456h2.256l.468-.456v-2.064l-.468-.468h-3.996V114.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L182.629 123h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__s)">
          <rect
            width={20}
            height={20}
            x={119}
            y={137}
            fill="url(#icon-spielberg-minimap-markers_svg__t)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__u)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M125.909 149.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L130.721 151h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__v)">
          <rect
            width={20}
            height={20}
            x={191}
            y={186}
            fill="url(#icon-spielberg-minimap-markers_svg__w)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__x)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M197.756 198.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L202.76 200h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__y)">
          <rect
            width={20}
            height={20}
            x={141}
            y={179}
            fill="url(#icon-spielberg-minimap-markers_svg__z)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__A)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M152.161 186.028v-.228h-4.248v-1.2h5.688v1.464L150.253 193h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__B)">
          <rect
            width={20}
            height={20}
            x={324}
            y={181}
            fill="url(#icon-spielberg-minimap-markers_svg__C)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__D)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M330.94 193.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L335.632 195h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
            />
          </g>
        </g>
        <g filter="url(#icon-spielberg-minimap-markers_svg__E)">
          <rect
            width={20}
            height={20}
            x={334}
            y={216}
            fill="url(#icon-spielberg-minimap-markers_svg__F)"
            rx={10}
          />
          <g filter="url(#icon-spielberg-minimap-markers_svg__G)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m339.841 223.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L348.059 230h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="icon-spielberg-minimap-markers_svg__c"
          width={72.246}
          height={88.213}
          x={202}
          y={244}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={3}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={4} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__d"
          width={36}
          height={36}
          x={146}
          y={262}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__f"
          width={19.227}
          height={24.4}
          x={153.992}
          y={267.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__g"
          width={36}
          height={36}
          x={28}
          y={130}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__i"
          width={21.832}
          height={24.4}
          x={34.957}
          y={135.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__j"
          width={36}
          height={36}
          x={23}
          y={75}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__l"
          width={22}
          height={24.4}
          x={29.785}
          y={80.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__m"
          width={36}
          height={36}
          x={195}
          y={93}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__o"
          width={22.492}
          height={24.4}
          x={201.629}
          y={98.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__p"
          width={36}
          height={36}
          x={163}
          y={103}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__r"
          width={21.973}
          height={24.4}
          x={169.891}
          y={108.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__s"
          width={36}
          height={36}
          x={111}
          y={131}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__u"
          width={22.047}
          height={24.4}
          x={117.91}
          y={136.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__v"
          width={36}
          height={36}
          x={183}
          y={180}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__x"
          width={22.242}
          height={24.4}
          x={189.754}
          y={185.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__y"
          width={36}
          height={36}
          x={133}
          y={173}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__A"
          width={21.688}
          height={24.4}
          x={139.914}
          y={178.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__B"
          width={36}
          height={36}
          x={316}
          y={175}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__D"
          width={22.047}
          height={24.4}
          x={322.82}
          y={180.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__E"
          width={36}
          height={36}
          x={326}
          y={210}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <filter
          id="icon-spielberg-minimap-markers_svg__G"
          width={27.387}
          height={24.4}
          x={330.004}
          y={215.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9534_161166"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9534_161166"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9534_161166"
            result="effect2_dropShadow_9534_161166"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9534_161166"
            result="shape"
          />
        </filter>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__b"
          x1={11}
          x2={364.092}
          y1={188.177}
          y2={188.177}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FC5BA" />
          <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__e"
          x1={174}
          x2={154}
          y1={268}
          y2={288}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__h"
          x1={56}
          x2={36}
          y1={136}
          y2={156}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__k"
          x1={51}
          x2={31}
          y1={81}
          y2={101}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__n"
          x1={223}
          x2={203}
          y1={99}
          y2={119}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__q"
          x1={191}
          x2={171}
          y1={109}
          y2={129}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__t"
          x1={139}
          x2={119}
          y1={137}
          y2={157}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__w"
          x1={211}
          x2={191}
          y1={186}
          y2={206}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__z"
          x1={161}
          x2={141}
          y1={179}
          y2={199}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__C"
          x1={344}
          x2={324}
          y1={181}
          y2={201}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-spielberg-minimap-markers_svg__F"
          x1={354}
          x2={334}
          y1={216}
          y2={236}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <clipPath id="icon-spielberg-minimap-markers_svg__a">
          <path fill="#fff" d="M0 0h375v375H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
export default SvgIconSpielbergMinimapMarkers;
